import { useAuthGate, AuthModal } from './AuthGate';
import React, { useState, useEffect, useRef } from 'react';

const API = '';
const getHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('nomokratia_token')}` });

const TEMPLATES = {
  // === ΒΑΣΙΚΑ ΔΙΚΟΓΡΑΦΑ ===
  agogi:{name:'Αγωγή',icon:'⚔️',desc:'Αγωγή ενώπιον δικαστηρίου',cat:'Δικόγραφα',needs:['client_name','opposing_party','court','facts']},
  protaseis:{name:'Προτάσεις',icon:'📑',desc:'Προτάσεις ενώπιον δικαστηρίου',cat:'Δικόγραφα',needs:['client_name','opposing_party','court','facts']},
  aitisi:{name:'Αίτηση',icon:'📨',desc:'Αίτηση προς δικαστήριο / αρχή',cat:'Δικόγραφα',needs:['client_name','court','facts']},
  aitisi_asf:{name:'Ασφαλιστικά Μέτρα',icon:'⚡',desc:'Αίτηση ασφαλιστικών μέτρων (ΚΠολΔ 682)',cat:'Δικόγραφα',needs:['client_name','opposing_party','court','facts']},
  diatagi_pliromis:{name:'Διαταγή Πληρωμής',icon:'💰',desc:'Αίτηση για έκδοση διαταγής πληρωμής',cat:'Δικόγραφα',needs:['client_name','opposing_party','court','facts','amount']},
  // === ΕΝΔΙΚΑ ΜΕΣΑ ===
  anakopi:{name:'Ανακοπή',icon:'🛑',desc:'Ανακοπή κατά διαταγής πληρωμής / εκτέλεσης',cat:'Ένδικα Μέσα',needs:['client_name','opposing_party','court','facts']},
  efesi:{name:'Έφεση',icon:'📤',desc:'Έφεση κατά πρωτόδικης απόφασης',cat:'Ένδικα Μέσα',needs:['client_name','opposing_party','court','facts']},
  anairesi:{name:'Αναίρεση',icon:'🔝',desc:'Αναίρεση ενώπιον Αρείου Πάγου',cat:'Ένδικα Μέσα',needs:['client_name','opposing_party','court','facts']},
  // === ΠΟΙΝΙΚΑ ===
  minytoria:{name:'Μηνυτήρια Αναφορά',icon:'🚨',desc:'Μηνυτήρια αναφορά / έγκληση',cat:'Ποινικά',needs:['client_name','opposing_party','facts']},
  apologitiko:{name:'Απολογητικό Υπόμνημα',icon:'🛡️',desc:'Υπόμνημα υπεράσπισης κατηγορουμένου',cat:'Ποινικά',needs:['client_name','court','facts']},
  // === ΕΞΩΔΙΚΑΣΤΙΚΑ ===
  exodiko:{name:'Εξώδικο',icon:'📩',desc:'Εξώδικη δήλωση / πρόσκληση / διαμαρτυρία',cat:'Εξωδικαστικά',needs:['client_name','opposing_party','facts']},
  symvasi:{name:'Σύμβαση',icon:'📄',desc:'Σύμβαση παροχής υπηρεσιών / έργου',cat:'Εξωδικαστικά',needs:['client_name','opposing_party','facts']},
  idiotiko:{name:'Ιδιωτικό Συμφωνητικό',icon:'✍️',desc:'Ιδιωτικό συμφωνητικό μεταξύ μερών',cat:'Εξωδικαστικά',needs:['client_name','opposing_party','facts']},
  misthotiro:{name:'Μισθωτήριο',icon:'🏠',desc:'Σύμβαση μίσθωσης ακινήτου',cat:'Εξωδικαστικά',needs:['client_name','opposing_party','facts','amount']},
  pliresousio:{name:'Πληρεξούσιο',icon:'🔑',desc:'Πληρεξούσιο / εξουσιοδότηση',cat:'Εξωδικαστικά',needs:['client_name','facts']},
  praktiko:{name:'Πρακτικό Συμβιβασμού',icon:'🤝',desc:'Πρακτικό εξωδικαστικού συμβιβασμού',cat:'Εξωδικαστικά',needs:['client_name','opposing_party','facts','amount']},
  // === ΛΟΙΠΑ ===
  gnomodoatisi:{name:'Γνωμοδότηση',icon:'📋',desc:'Νομική γνωμοδότηση / γνώμη',cat:'Λοιπά',needs:['client_name','facts']},
  enorki:{name:'Ένορκη Βεβαίωση',icon:'📜',desc:'Ένορκη βεβαίωση ενώπιον Ειρηνοδίκη',cat:'Λοιπά',needs:['client_name','court','facts']},
};

const COURTS = [
  'Μονομελές Πρωτοδικείο Θεσσαλονίκης','Πολυμελές Πρωτοδικείο Θεσσαλονίκης',
  'Ειρηνοδικείο Θεσσαλονίκης','Μονομελές Πρωτοδικείο Αθηνών',
  'Πολυμελές Πρωτοδικείο Αθηνών','Ειρηνοδικείο Αθηνών',
  'Διοικητικό Πρωτοδικείο Θεσσαλονίκης','Εφετείο Θεσσαλονίκης',
  'Άρειος Πάγος','Συμβούλιο της Επικρατείας',
];

const DocGenerator = () => {
  const [step, setStep] = useState(1);
  const [docType, setDocType] = useState('');
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [cases, setCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState('');
  const [form, setForm] = useState({
    client_name:'',client_vat:'',client_address:'',
    opposing_party:'',opposing_address:'',
    court:'',city:'Θεσσαλονίκη',
    facts:'',legal_basis:'',subject:'',amount:'',
    lawyer_name:'',custom_instructions:'',
    include_jurisprudence:true,
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [editedContent, setEditedContent] = useState('');
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);
  const editorRef = useRef(null);
  const { showModal, setShowModal, guardedAction, onSuccess } = useAuthGate();

  useEffect(() => {
    fetch(API+'/api/crm/clients', {headers: getHeaders()}).then(r=>r.json()).then(data => {
      if (Array.isArray(data)) setClients(data);
      else if (data.clients) setClients(data.clients);
    }).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!selectedClient) return;
    fetch(API+'/api/crm/cases?client_id='+selectedClient, {headers: getHeaders()}).then(r=>r.json()).then(data => {
      if (Array.isArray(data)) setCases(data);
      else if (data.cases) setCases(data.cases);
    }).catch(()=>{});
  }, [selectedClient]);

  const handleClientSelect = async (id) => {
    setSelectedClient(id);
    if (!id) return;
    try {
      const r = await fetch(API+'/api/documents/crm-autofill/'+id);
      const d = await r.json();
      if (!d.error) setForm(p=>({...p,client_name:d.client_name||p.client_name,client_vat:d.client_vat||p.client_vat,client_address:d.client_address||p.client_address}));
    } catch(e){}
  };

  const handleCaseSelect = async (id) => {
    setSelectedCase(id);
    if (!id||!selectedClient) return;
    try {
      const r = await fetch(API+'/api/documents/crm-autofill/'+selectedClient+'?case_id='+id);
      const d = await r.json();
      if (!d.error) setForm(p=>({...p,opposing_party:d.opposing_party||p.opposing_party,court:d.court||p.court,facts:d.facts||p.facts}));
    } catch(e){}
  };

  const handleGenerate = async () => {
    setLoading(true); setError(null); setEditedContent('');
    setResult({success:true, content:'', download_id:null, doc_name:(TEMPLATES[docType]?.name||'Έγγραφο')+' - '+(form.client_name||'')});
    setStep(3);
    let acc = '';
    try {
      const r = await fetch(API+'/api/documents/generate-stream', {
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({doc_type:docType,...form,amount:form.amount?parseFloat(form.amount):null,case_id:selectedCase||null,client_id:selectedClient||null})
      });
      if (!r.ok) throw new Error('HTTP '+r.status);
      const reader = r.body.getReader();
      const decoder = new TextDecoder();
      let buf = '';
      while (true) {
        const {value, done} = await reader.read();
        if (done) break;
        buf += decoder.decode(value, {stream:true});
        const lines = buf.split('\n');
        buf = lines.pop();
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          let ev;
          try { ev = JSON.parse(line.slice(6)); } catch(_) { continue; }
          if (ev.type === 'token') {
            acc += ev.text;
            const clean = acc.replace(/\*\*/g,'').replace(/###/g,'').replace(/##/g,'').replace(/#/g,'').replace(/\*/g,'');
            setEditedContent(clean);
          } else if (ev.type === 'done') {
            const clean = acc.replace(/\*\*/g,'').replace(/###/g,'').replace(/##/g,'').replace(/#/g,'').replace(/\*/g,'');
            setResult({success:true, content:clean, download_id:ev.download_id, doc_name:ev.doc_name});
            setEditedContent(clean);
          } else if (ev.type === 'error') {
            setError(ev.message || 'Error');
          }
        }
      }
    } catch(e){ setError(e.message); }
    setLoading(false);
  };

  const handleDownload = async () => {
    const id = result && result.download_id;
    if (!id) { setError('Δημιουργήστε πρώτα το έγγραφο.'); return; }
    try {
      const resp = await fetch(API + '/api/documents/download/' + id);
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = ((result.doc_name || 'Eggrafo') + '.docx');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function(){ URL.revokeObjectURL(url); }, 1500);
    } catch (e) {
      setError('Σφάλμα λήψης: ' + e.message);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(editedContent);
    setSaved(true);
    setTimeout(()=>setSaved(false), 2000);
  };

  const inp = {width:'100%',padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:14,outline:'none'};
  const lbl = {display:'block',fontSize:13,fontWeight:600,color:'#374151',marginBottom:4};

  return (
    <div style={{maxWidth:1000,margin:'0 auto',padding:24}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:22,fontWeight:700,color:'#1E293B',display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:28}}>📝</span> Αυτόματη Δημιουργία Εγγράφων
        </h2>
        <p style={{fontSize:14,color:'#64748B'}}>AI δημιουργία νομικών εγγράφων με CRM + Νομολογία από 3.5M έγγραφα</p>
      </div>

      {/* Step 1: Choose Template */}
      {step===1 && (
        <div>
          <h3 style={{fontSize:16,fontWeight:700,color:'#1E293B',marginBottom:16}}>Βήμα 1: Επιλέξτε τύπο εγγράφου</h3>
          {(() => {
            const cats = {};
            Object.entries(TEMPLATES).forEach(([key,t]) => {
              const c = t.cat || 'Λοιπά';
              if (!cats[c]) cats[c] = [];
              cats[c].push([key,t]);
            });
            const catMeta = {
              'Δικόγραφα':{icon:'⚖️',color:'#1E40AF'},
              'Ένδικα Μέσα':{icon:'📤',color:'#9333EA'},
              'Ποινικά':{icon:'🚨',color:'#DC2626'},
              'Εξωδικαστικά':{icon:'📩',color:'#047857'},
              'Λοιπά':{icon:'📋',color:'#64748B'},
            };
            return Object.entries(cats).map(([cat, items]) => (
              <div key={cat} style={{marginBottom:20}}>
                <div style={{fontSize:13,fontWeight:700,color:(catMeta[cat]||{}).color||'#475569',marginBottom:8,display:'flex',alignItems:'center',gap:6}}>
                  <span>{(catMeta[cat]||{}).icon||'📄'}</span> {cat}
                  <span style={{fontSize:11,fontWeight:400,color:'#94A3B8'}}>({items.length})</span>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
                  {items.map(([key,t])=>(
                    <button key={key} onClick={()=>{setDocType(key);setStep(2);}} style={{
                      padding:'14px 16px',borderRadius:12,border:'2px solid '+(docType===key?'#3B82F6':'#E2E8F0'),
                      background:docType===key?'#EFF6FF':'#FFF',cursor:'pointer',textAlign:'left',transition:'all 0.2s',
                    }}
                    onMouseEnter={e=>{if(docType!==key){e.currentTarget.style.borderColor='#93C5FD';e.currentTarget.style.background='#F8FAFC';}}}
                    onMouseLeave={e=>{if(docType!==key){e.currentTarget.style.borderColor='#E2E8F0';e.currentTarget.style.background='#FFF';}}}
                    >
                      <div style={{display:'flex',alignItems:'center',gap:10}}>
                        <span style={{fontSize:24}}>{t.icon}</span>
                        <div>
                          <div style={{fontSize:14,fontWeight:700,color:'#1E293B'}}>{t.name}</div>
                          <div style={{fontSize:11,color:'#64748B',marginTop:2}}>{t.desc}</div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            ));
          })()}
        </div>
      )}

      {/* Step 2: Fill Data */}
      {step===2 && (
        <div>
          <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:20}}>
            <button onClick={()=>setStep(1)} style={{padding:'6px 12px',borderRadius:8,border:'1px solid #E2E8F0',background:'#FFF',cursor:'pointer',fontSize:13}}>&#8592; Πίσω</button>
            <h3 style={{fontSize:16,fontWeight:700,color:'#1E293B',margin:0}}>{TEMPLATES[docType]?.icon} {TEMPLATES[docType]?.name} - Στοιχεία</h3>
          </div>
          <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.04)'}}>
            {clients.length > 0 && (<div style={{background:'#F0F9FF',borderRadius:12,padding:16,marginBottom:20,border:'1px solid #BAE6FD'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#0369A1',marginBottom:8}}>&#128279; Αυτόματη συμπλήρωση από CRM</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <label style={{...lbl,fontSize:12}}>Πελάτης</label>
                  <select value={selectedClient} onChange={e=>handleClientSelect(e.target.value)} style={{...inp,cursor:'pointer',fontSize:13}}>
                    <option value="">-- Επιλέξτε πελάτη --</option>
                    {clients.map(c=>(<option key={c._id||c.id} value={c._id||c.id}>{c.name||c.full_name}</option>))}
                  </select>
                </div>
                <div>
                  <label style={{...lbl,fontSize:12}}>Υπόθεση</label>
                  <select value={selectedCase} onChange={e=>handleCaseSelect(e.target.value)} style={{...inp,cursor:'pointer',fontSize:13}} disabled={!selectedClient}>
                    <option value="">-- Επιλέξτε υπόθεση --</option>
                    {cases.map(c=>(<option key={c._id||c.id} value={c._id||c.id}>{c.title||c.description}</option>))}
                  </select>
                </div>
              </div>
            </div>)}
            <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:16,marginBottom:16}}>
              <div><label style={lbl}>&#128100; Εντολέας *</label><input type="text" value={form.client_name} onChange={e=>setForm({...form,client_name:e.target.value})} style={inp} placeholder="Ονοματεπώνυμο"/></div>
              <div><label style={lbl}># ΑΦΜ</label><input type="text" value={form.client_vat} onChange={e=>setForm({...form,client_vat:e.target.value})} style={inp} placeholder="123456789" maxLength={9}/></div>
            </div>
            <div style={{marginBottom:16}}><label style={lbl}>&#128205; Διεύθυνση εντολέα</label><input type="text" value={form.client_address} onChange={e=>setForm({...form,client_address:e.target.value})} style={inp}/></div>
            {TEMPLATES[docType]?.needs.includes('opposing_party') && (
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
                <div><label style={lbl}>&#9876;&#65039; Αντίδικος *</label><input type="text" value={form.opposing_party} onChange={e=>setForm({...form,opposing_party:e.target.value})} style={inp}/></div>
                <div><label style={lbl}>&#128205; Διεύθυνση αντιδίκου</label><input type="text" value={form.opposing_address} onChange={e=>setForm({...form,opposing_address:e.target.value})} style={inp}/></div>
              </div>
            )}
            {TEMPLATES[docType]?.needs.includes('court') && (
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
                <div><label style={lbl}>&#127963;&#65039; Δικαστήριο *</label>
                  <select value={form.court} onChange={e=>setForm({...form,court:e.target.value})} style={{...inp,cursor:'pointer'}}>
                    <option value="">-- Επιλέξτε --</option>
                    {COURTS.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div><label style={lbl}>&#128205; Πόλη</label><input type="text" value={form.city} onChange={e=>setForm({...form,city:e.target.value})} style={inp}/></div>
              </div>
            )}
            <div style={{marginBottom:16}}>
              <label style={lbl}>&#128221; Ιστορικό / Πραγματικά Περιστατικά *</label>
              <textarea value={form.facts} onChange={e=>setForm({...form,facts:e.target.value})} style={{...inp,minHeight:120,resize:'vertical'}} placeholder="Περιγράψτε τα πραγματικά περιστατικά..."/>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:16,marginBottom:16}}>
              <div><label style={lbl}>&#9878;&#65039; Νομική Βάση</label><input type="text" value={form.legal_basis} onChange={e=>setForm({...form,legal_basis:e.target.value})} style={inp} placeholder="π.χ. Άρθρα 914, 932 ΑΚ"/></div>
              <div><label style={lbl}>&#128176; Ποσό</label><input type="number" value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})} style={inp} placeholder="0.00"/></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
              <div><label style={lbl}>&#128104;&#8205;&#9878;&#65039; Δικηγόρος</label><input type="text" value={form.lawyer_name} onChange={e=>setForm({...form,lawyer_name:e.target.value})} style={inp}/></div>
              <div><label style={lbl}>&#128172; Ειδικές οδηγίες</label><input type="text" value={form.custom_instructions} onChange={e=>setForm({...form,custom_instructions:e.target.value})} style={inp}/></div>
            </div>
            <div style={{display:'flex',gap:24,marginBottom:20}}>
              <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:'#475569',cursor:'pointer'}}>
                <input type="checkbox" checked={form.include_jurisprudence} onChange={e=>setForm({...form,include_jurisprudence:e.target.checked})}/> &#128218; Νομολογία (3.5M έγγραφα)
              </label>
            </div>
            <button onClick={()=>guardedAction(handleGenerate)} disabled={loading||!form.facts.trim()||!form.client_name.trim()} style={{
              width:'100%',padding:'14px',borderRadius:12,background:loading?'#94A3B8':'linear-gradient(135deg,#1E293B,#334155)',
              color:'#FFF',fontSize:15,fontWeight:700,border:'none',cursor:loading?'wait':'pointer',
            }}>
              {loading?'&#9203; Δημιουργία με AI...':'&#128221; Δημιουργία '+(TEMPLATES[docType]?.name||'')}
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Edit & Download */}
      {step===3 && result && (
        <div>
          {/* Toolbar */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:12}}>
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <button onClick={()=>setStep(2)} style={{padding:'6px 12px',borderRadius:8,border:'1px solid #E2E8F0',background:'#FFF',cursor:'pointer',fontSize:13}}>&#8592; Πίσω</button>
              <h3 style={{fontSize:18,fontWeight:700,color:'#1E293B',margin:0}}>
                {TEMPLATES[docType]?.icon} {result.doc_name}
              </h3>
            </div>
            <div style={{display:'flex',gap:8,alignItems:'center'}}>
              <span style={{fontSize:12,color:'#94A3B8'}}>{editedContent.split(/\s+/).length} λέξεις</span>
              {saved && <span style={{fontSize:12,color:'#059669',fontWeight:600}}>&#10003; Αντιγράφηκε!</span>}
              <button onClick={handleCopy} style={{padding:'8px 16px',borderRadius:10,background:'#3B82F6',color:'#FFF',fontSize:13,fontWeight:700,border:'none',cursor:'pointer'}}>
                &#128203; Αντιγραφή
              </button>
              <button onClick={handleDownload} style={{padding:'8px 16px',borderRadius:10,background:'#059669',color:'#FFF',fontSize:13,fontWeight:700,border:'none',cursor:'pointer'}}>
                &#128229; Λήψη .docx
              </button>
              <button onClick={()=>{setResult(null);setEditedContent('');setDocType('');setStep(1);setForm({
                client_name:'',client_vat:'',client_address:'',opposing_party:'',opposing_address:'',
                court:'',city:'Θεσσαλονίκη',facts:'',legal_basis:'',subject:'',amount:'',
                lawyer_name:'',custom_instructions:'',include_jurisprudence:true
              });}} style={{padding:'8px 16px',borderRadius:10,background:'#F1F5F9',color:'#475569',fontSize:13,fontWeight:600,border:'1px solid #E2E8F0',cursor:'pointer'}}>
                &#10133; Νέο
              </button>
            </div>
          </div>

          {/* AI-Transparenz-Hinweis (EU AI Act Art. 50) */}
          <div style={{background:'#EFF6FF',borderRadius:10,padding:'10px 16px',marginBottom:10,border:'1px solid #BFDBFE',fontSize:13,color:'#1E3A8A',display:'flex',alignItems:'center',gap:8,fontWeight:600}}>
            &#129302; Το περιεχόμενο δημιουργήθηκε από τεχνητή νοημοσύνη (AI) και απαιτεί έλεγχο από δικηγόρο.
          </div>
          {/* Info bar */}
          <div style={{background:'#FFFBEB',borderRadius:10,padding:'10px 16px',marginBottom:12,border:'1px solid #FDE68A',fontSize:13,color:'#92400E',display:'flex',alignItems:'center',gap:8}}>
            &#9999;&#65039; Κάντε κλικ στο κείμενο για να επεξεργαστείτε απευθείας. Οι αλλαγές σας αποθηκεύονται αυτόματα.
          </div>

          {/* Jurisprudence */}
          {result.jurisprudence_used && result.jurisprudence_used.length>0 && (
            <div style={{background:'#F0F9FF',borderRadius:12,padding:14,marginBottom:12,border:'1px solid #BAE6FD'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#0369A1',marginBottom:6}}>&#128218; Νομολογία:</div>
              {result.jurisprudence_used.map((j,i)=>(<div key={i} style={{fontSize:12,color:'#475569',padding:'2px 0'}}>&#8226; {j}</div>))}
            </div>
          )}

          {/* Editable Document */}
          <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',overflow:'hidden',boxShadow:'0 4px 12px rgba(0,0,0,0.06)'}}>
            <div style={{padding:'12px 20px',background:'#F8FAFC',borderBottom:'1px solid #E2E8F0',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span style={{fontSize:14,fontWeight:700,color:'#1E293B'}}>&#128196; Έγγραφο - Κάντε κλικ για επεξεργασία</span>
              <span style={{fontSize:11,color:'#94A3B8'}}>Επεξεργάσιμο</span>
            </div>
            <textarea
              ref={editorRef}
              value={editedContent}
              onChange={e=>setEditedContent(e.target.value)}
              style={{
                width:'100%',
                minHeight:600,
                padding:'40px 48px',
                border:'none',
                outline:'none',
                resize:'vertical',
                fontFamily:'Georgia, "Times New Roman", serif',
                fontSize:14,
                lineHeight:1.9,
                color:'#1E293B',
                background:'#FFF',
                boxSizing:'border-box',
              }}
            />
          </div>
        </div>
      )}

      {/* Error */}
      <AuthModal show={showModal} onClose={()=>setShowModal(false)} onSuccess={onSuccess} />
      {error && <div style={{marginTop:16,padding:16,borderRadius:12,background:'#FEF2F2',border:'1px solid #FECACA',color:'#991B1B',fontSize:14}}>&#10060; {error}</div>}
    </div>
  );
};

export default DocGenerator;
